export default __webpack_public_path__ + "static/media/titiro-logo.f561f3a3.svg";